var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"screenOverlay fixed h-screen w-screen bg-trans-black-08 top-0 right-0 transition-opacity duration-300 ease-in-out",class:[_vm.screenOpen ? 'screenOverlay--open': ''],on:{"click":function($event){return _vm.$emit('closeScreen')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }